module.exports = __webpack_public_path__ + "img/qr_watch_300.7e22fb83.png";